
const produtoGridConfig = {
  idField: "idProduto",
  columns: [
    { header: "Código", field: "REFERENCIA" },
    { header: "Descrição", field: "DESCRICAO" },
    { header: "Valor", field: "VALOR" }, 
    { header: "Custo", field: "CUSTO" },
    { header: "Validade", field: "VALIDADE" },
    { header: "Ativo", field: "ATIVO",
    formatter: (value) => (value ? "Sim" : "Não")
  }
  ]
};

export default produtoGridConfig;